import {
  DEFAULT_ICON_COLOR,
  DEFAULT_ICON_SIZE,
} from "@oneleet/config/constants";
import { cn } from "@oneleet/utils";

export function CustomFirewallIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      className={cn(
        "fill-transparent stroke-current",
        DEFAULT_ICON_SIZE,
        DEFAULT_ICON_COLOR,
        className,
      )}
    >
      <g>
        <path
          d="M8 6V10M10.6656 10V14M10.6656 2V6M2 10H14M2 6H14M5.33437 10V14M5.33437 2V6M3.33333 2H12.6667C13.403 2 14 2.59695 14 3.33333V12.6667C14 13.403 13.403 14 12.6667 14H3.33333C2.59695 14 2 13.403 2 12.6667V3.33333C2 2.59695 2.59695 2 3.33333 2Z"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
